<template>
    <el-dialog
        :visible.sync="visible"
        :show-close="true"
        :close-on-click-modal="false"
        custom-class="noHeaderFooter"
        class="e-dialog"
        :class="{'img_dialog': fileType === 'img'}"
        :before-close="closeDialog"
    >   
        <div slot="title">
            <div class="exercise_title SysFontM">{{templateItem.templateName || '--'}}</div>
            <div class="exercise_date AkrobatR">{{templateItem.createTime ? $utils.formatTime('YYYY/MM/DD HH:mm:ss', new Date(templateItem.createTime)) : '--'}}</div>
        </div>
        <div class="dialog_con" :style="{'background':dataInfo.backgroundColor}">
            <div class="dialog_con_left">
                <!-- 视频 -->
                <video
                    :src="dataInfo.drawAnimatedUrl"
                    v-if="fileType === 'video'"
                    controls
                    controlslist="nodownload noplaybackrate"
                    oncontextmenu="return false"
                    disablepictureinpicture
                    autoplay
                ></video>
                <!-- 图片 -->
                <img
                    v-else-if="fileType === 'img'"
                    :src="dataInfo.drawingThumbnail"
                />
            </div>
            <div class="dialog_con_right" :style="{color:dataInfo.backgroundColor === '#F0F0F0' ? '#81818A' : ''}">
                <img :src="getNotes" alt="" class="mb4">
                <p>
                    <pre>{{dataInfo.notes ? dataInfo.notes : ''}}</pre>
                </p>
            </div>
        </div>
       
    </el-dialog>
</template>

<script>
/**
* @author zhangshishuo
* @description  图片，视频弹窗
* @param {Boolean}  visible  控制显示隐藏
* @param {String}  fileType  视频/video、图片/img
* @param {Object}  dataInfo  教案详情 
*/
export default {
    name: 'animation-dialog',
    props:{
        dataInfo:{
            type: Object,
            default: ()=>{}
        },
        visible: {
            type: Boolean,
            default: false,
        },
        fileType: {
            type: String,
            default: 'video'
        },
        templateItem: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return{

        }
    },
    watch: {
        
    },
    computed:{
        getNotes(){
            if (this.dataInfo.backgroundColor === '#2B8E5E') {
                return require('@i/exercise/exercise_notes.svg')
            } else if (this.dataInfo.backgroundColor === '#F0F0F0') {
                return require('@i/exercise/white_notes.svg')
            } else {
                return require('@i/exercise/gray_notes.svg')
            }
        }
    },
    methods: {
        closeDialog() {
            this.$emit('updateVisible');
        }
    }
}
</script>

<style lang="scss" scoped>
.img_dialog {   // 图片类型下内容区域不可溢出
    ::v-deep .el-dialog {
        overflow: hidden !important;
    }
}
::v-deep .el-dialog__body {
    height:calc(100% - 58px)  !important;
}
::v-deep .el-dialog {
    overflow: initial;
    width: 863px;
    height: 715px;
    margin: 0px !important;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-49%, -50%);
    max-height: 90%;
    background: #fff;
    .dialog_con{
        background: #3CA26B;
        padding-left: 22px;
        border-radius: 6px;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        .dialog_con_left{
            width: 476px;
            height: 100%;
            img,video{
                height: 100%;
                width: 100%;
            }
        }
        .dialog_con_right{
            border: 1 dashed rgba(37, 131, 80, 0.25);
            flex: 1;
            padding: 21px;
            color: #FFFFFF;
            p{
                height: calc(100% - 45px);
                overflow: hidden;
                overflow-y: auto;
                padding: 12px 16px;
                background: url('~@i/exercise/notes_background_normal.svg');
                border-radius: 4px;
                pre{
                    font-size: 14px;
                    line-height: 24px;
                    
                }
            }
        }
    }
    // overflow-x: auto;
}
::v-deep .el-dialog.noHeaderFooter {
    .el-dialog__header{
        padding: 10px 24px;
        text-align: left;
        .exercise_title{
            font-size: 14px;
            line-height: 20px;
            color: #3A3A3A;
        }
        .exercise_date{
            font-size: 14px;
            line-height: 17px;
            color: #705F5F;
        }
    }
    .el-dialog__footer {
        display: none;
    }
    .el-dialog__body {
        background: none;
        box-sizing: border-box;
        padding: 0 24px 24px;
        margin: 0;
        line-height: 0;
        &>img{
            width: 100%;
        }
    }
}
video {
    width: 100%;
    border-radius: 18px;
    outline: none;
}

// 全屏禁用
video::-webkit-media-controls-fullscreen-button {
    display: none !important;
}
// 音量按钮
video::-webkit-media-controls-volume-control-container {
  display: none !important;
}
video::-internal-track-segment-highlight-before{
    background: #38CB89 !important;
}
// 更多选项
video::-webkit-media-controls:not(.audio-only) input[pseudo="-webkit-media-controls-timeline" i]::-internal-track-segment-highlight-before  {
    display: none !important;
}
video::-internal-media-controls-button-hover-background {
    display: none !important;
}
</style>